export class UserSettingDetails {
  id!: number;
  userId!: number;
  timeZoneId!: number;
  dateFormat!: string;
  languageId!: number;
  theme!: string;
  layout!: string;
  timeZoneList!: TimeZoneList[];
  languageList!: LanguageList[];
}

export class TimeZoneList {
  id!: number;
  timeZoneGMT!: string;
  diffTimeByMinutes!: number;
}

export class LanguageList {
  id!: number;
  language!: string;
}
